import React from 'react';
import { PersonalInfoSection } from './PersonalInfoSection';

/**
 * Account Tab
 * Contains personal information section
 */
export const AccountTab: React.FC = () => {
  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 md:px-8 py-8">
      <div className="space-y-6">
        <PersonalInfoSection />
      </div>
    </div>
  );
};
